import React, { useState, useEffect } from 'react';
import {
    Layout,
    Select,
    Input,
    Button,
    Table,
    Modal,
    message,
    Pagination,
    Form, AutoComplete,
} from 'antd';
import axios from '../../axios';
import {copyToClipboard, fetchTokenOptions, formattedAddress, tokenOptions} from "../../util";
import {useNavigate} from "react-router-dom";
import './ManageWallet.css';

const { Content } = Layout;
const { Option } = Select;

const ManageWallet = () => {
    const navigate = useNavigate();
    const [walletGroups, setWalletGroups] = useState([]);
    const [selectedGroup, setSelectedGroup] = useState(null);
    const [searchAddress, setSearchAddress] = useState('');
    const [tokenAddress, setTokenAddress] = useState('');
    const [wallets, setWallets] = useState([]);
    const [pagination, setPagination] = useState({ current: 1, pageSize: 20, total: 0, });
    const [loading, setLoading] = useState(false);
    const [totalBalance, setTotalBalance] = useState(null);
    const [selectedRows, setSelectedRows] = useState([]);
    const [addAddressModalVisible, setAddAddressModalVisible] = useState(false);
    const [addPrivateKey, setAddPrivateKey] = useState('');
    const [highlightedRow, setHighlightedRow] = useState(null);
    const [chains, setChains] = useState([]);  // 新增：存储链的列表
    const [selectedChain, setSelectedChain] = useState(null);  // 新增：选中的链
    const [options, setOptions] = useState([]);
    const [form] = Form.useForm();

    // 示例链列表
    const showchains = [
        { chain_id: 'bsc', chain_name: 'BSC' },
        { chain_id: 'base', chain_name: 'Base' },
    ];

    const [tokenOptions, setTokenOptions] = useState({});

    useEffect(() => {
        const loadTokenOptions = async () => {
            const data = await fetchTokenOptions();
            setTokenOptions(data);
        };

        loadTokenOptions();
    }, []);

    // useEffect(() => {
    //     if (selectedChain) {
    //         const newOptions = tokenOptions[selectedChain.chain_name]?.map((token) => ({
    //             value: token.address,
    //             label: `${token.name} - ${token.address}`,
    //         })) || [];
    //         console.log("selected chain: ", selectedChain)
    //         setOptions(newOptions);
    //         console.log(newOptions);
    //     } else {
    //         setOptions([]);
    //     }
    // }, [selectedChain, tokenOptions]);

    // 加载钱包组列表
    useEffect(() => {
        fetchWalletGroups();
        fetchChains(); // 获取链的列表
        // fetchWallets();
    }, []);

    useEffect(() => {
        if (selectedGroup) {
            fetchWallets(); // 在 selectedGroup 更新后调用 fetchWallets
        }
    }, [selectedGroup, selectedChain]);

    const fetchChains = async () => {
        try {
            const response = await axios.get('/api/v1/chain/list');
            if (response.data.code === 0) {
                setChains(Object.values(response.data.data));  // 提取链的列表
            } else {
                message.error(response.data.msg);
            }
        } catch(error) {
            message.error(error);
        }
    };


    const fetchWalletGroups = async (name = '') => {
        try {
            const token = localStorage.getItem('token');
            const response = await axios.get('/api/v1/wallet/list', {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                params: { name, page: 1, size: 999 },
                navigate: navigate // 传递 navigate
            });
            if (response.data.code === 0) {
                setWalletGroups(response.data.data.items);
            } else {
                if(response.data.code === -5) {
                    console.log("token 过期")
                    message.error('token 过期');
                    navigate('/login');
                } else {
                    message.error(response.data.msg);
                }
            }
        } catch(error) {
            message.error(error);
        }
    };

    // 搜索地址对应的钱包组
    const searchByAddress = async () => {
        if (!searchAddress) {
            message.warning('请输入地址');
            return;
        }
        try {
            const token = localStorage.getItem('token');
            const response = await axios.get('/api/v1/wallet/list', {
                params: { address: searchAddress },
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (response.data.code === 0) {
                const { total, items } = response.data.data;

                if (total > 0 && items && items.length > 0) {
                    // 如果找到钱包组
                    const groupId = items[0].group_id; // 假设返回的第一个匹配的项
                    const groupName = items[0].name;
                    setSelectedGroup(groupId); // 自动选择搜索结果
                    message.success(`找到钱包组：${items[0].name}`);

                    // 设置高亮地址
                    setHighlightedRow(searchAddress);

                    // 3 秒后取消高亮
                    setTimeout(() => {
                        setHighlightedRow(null);
                    }, 3000);
                } else {
                    // 如果没有找到钱包组
                    message.error('未找到该地址对应的钱包组');
                }
            } else {
                message.error(response.data.msg);
            }
        } catch (error) {
            message.error(error);
        }
    };


    // 查询余额
    const fetchWallets = async ( page = 1, size = 20) => {
        if (!selectedGroup) {
            message.warning('请选择钱包组');
            return;
        }
        console.log('fetch wallets: ', selectedGroup);
        setLoading(true);
        try {
            const token = localStorage.getItem('token');

            let params = { group_id: selectedGroup, page, size };

            if (tokenAddress) {
                const chainResponse = await axios.get('/api/v1/chain/list', {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });

                if (chainResponse.data.code === 0) {

                    params = { ...params, token_address: tokenAddress, chain_id: selectedChain?.chain_id };
                } else {
                    message.error(chainResponse.data.msg);
                    return;
                }
            }
            params = { ...params, token_address: tokenAddress, chain_id: selectedChain?.chain_id  };
            if (searchAddress) {
                params = {...params, account_address: searchAddress}
            }
            const response = await axios.get(`/api/v1/wallet/info`, {
                params,
                headers: {
                    Authorization: `Bearer ${token}`,
                    // Authorization: '1',
                },
            });

            if (response.data.code === 0) {
                const { items, total, total_balance } = response.data.data;
                // 排序钱包数据（假设每个钱包项有一个 balance 字段）
                const sortedItems = items.sort((a, b) => parseFloat(b.balance) - parseFloat(a.balance));

                setWallets(sortedItems);
                setTotalBalance(total_balance || '0');
                setPagination({ current: page, pageSize: size, total });
            } else {
                if(response.data.code === -5) {
                    console.log("token 过期")
                    message.error('token 过期');
                    navigate('/login');
                } else {
                    message.error(response.data.msg);
                }
            }
        } catch (error) {
            message.error(error);
        } finally {
            setLoading(false);
        }
    };


    // 导出私钥
    const exportPrivateKeys = async () => {
        if (!selectedGroup) {
            message.warning('请选择钱包组');
            return;
        }
        try {
            const token = localStorage.getItem('token');
            const response = await axios.post(`/api/v1/wallet/export`,
                { group_id: selectedGroup },
                { headers: { Authorization: `Bearer ${token}` } }
            );

            if (response.data.code === 0) {
                const { download_url } = response.data.data;

                // 使用 Modal 弹出窗口，方便用户复制
                Modal.info({
                    title: '私钥导出成功',
                    content: (
                        <div>
                            <p>文件路径：</p>
                            <Input.TextArea
                                autoSize={{ minRows: 1, maxRows: 3 }}
                                value={download_url}
                                readOnly
                            />
                        </div>
                    ),
                    okText: '关闭',
                });

            } else {
                message.error(response.data.msg);
            }
        } catch(error) {
            message.error(error);
        }
    };


    // 添加地址
    const addAddress = async (type) => {
        if (!selectedGroup) {
            message.warning('请选择钱包组');
            return;
        }
        const token = localStorage.getItem('token');
        try {
            const payload = { type: type,  chain_type:"evm", group_id: selectedGroup };
            if (type === 2) {
                if (!addPrivateKey) {
                    message.warning('请输入私钥');
                    return;
                }
                payload.private_key = addPrivateKey;
            }
            const response = await axios.post(`/api/v1/wallet/account/create`,
                payload,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    }
                }
            );
            if (response.data.code === 0) {
                message.success('添加地址成功');
                setAddAddressModalVisible(false);
                fetchWallets(); // 重新加载列表
            } else {
                console.log(response.data.code);
                console.log(response.data.data);
                message.error(response.data.msg);
            }
        } catch(error) {
            message.error(error);
        }
    };

    // 删除地址
    const deleteAddresses = async () => {
        if (selectedRows.length === 0) {
            message.warning('请选择要删除的地址');
            return;
        }

        try {
            const token = localStorage.getItem('token');

            // 准备请求参数
            const payload = {
                group_id: selectedGroup, // 假设 selectedGroup 是当前选中的钱包组 ID
                addresses: selectedRows.map((row) => row.address), // 选中的地址
            };

            // 发送删除请求
            const response = await axios.post('/api/v1/wallet/account/remove', payload, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            // 根据接口返回值处理
            if (response.data.code === 0) {
                message.success(`已删除 ${selectedRows.length} 个地址`);
                setSelectedRows([]); // 清空选中项
                fetchWallets();
            } else {
                message.error(response.data.msg);
            }
        } catch (error) {
            message.error(error);
        }
    };

    // 处理代币地址变化
    const handleTokenAddressChange = (value) => {
        setTokenAddress(value);
    };

    const columns = [
        {
            title: '序号',
            dataIndex: 'index',
            render: (_, __, index) => index + 1 + (pagination.current - 1) * pagination.pageSize,
        },
        {
            title: '钱包组名',
            dataIndex: 'group_name',
        },
        {
            title: '钱包地址',
            dataIndex: 'address',
            render: (text, record) => (
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    {/* 地址链接 */}
                    <a href={record.scan_url || `https://basescan.org/address/${text}`}
                       target="_blank"
                       rel="noopener noreferrer">
                        {formattedAddress(text)}
                    </a>

                    {/* 复制按钮 */}
                    <Button
                        size="small"
                        onClick={() => copyToClipboard(text)}>
                        复制
                    </Button>
                </div>
            ),
        },
        {
            title: '链类型',
            dataIndex: 'chain_type',
        },
        {
            title: '状态',
            dataIndex: 'status',
        },
        {
            title: '余额',
            dataIndex: 'balance',
            sorter: (a, b) => (Number(a.balance) || 0) - (Number(b.balance) || 0), // 处理空值
        },
    ];

    return (
        <Content style={{ padding: 20 }}>
            {/* 第一行：5 个元素 */}
            <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap', marginBottom: 10 }}>
                <Select
                                        allowClear
                    showSearch
                    placeholder="请选择钱包组"
                    value={selectedGroup}
                    onChange={(value) => setSelectedGroup(value)}
                    onSearch={fetchWalletGroups}
                    style={{ flex: 1, minWidth: '180px' }}
                >
                    {walletGroups.map((group) => (
                        <Option key={group.group_id} value={group.group_id}>
                            {group.name}
                        </Option>
                    ))}
                </Select>

                <Input
                    placeholder="输入钱包地址搜索"
                    value={searchAddress}
                    onChange={(e) => setSearchAddress(e.target.value)}
                    style={{ flex: 1, minWidth: '180px' }}
                />

                <Button type="primary" onClick={searchByAddress} style={{ flex: 1, minWidth: '180px' }}>
                    搜索
                </Button>

                <Button onClick={exportPrivateKeys} style={{ flex: 1, minWidth: '180px' }}>
                    导出私钥
                </Button>

                <Button type="primary" onClick={() => setAddAddressModalVisible(true)} style={{ flex: 1, minWidth: '180px' }}>
                    添加地址
                </Button>
            </div>

            {/* 第二行：5 个元素 */}
            <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap', marginBottom: 20 }}>
                <Form form={form} style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                <Form.Item name="chain_id" rules={[{ required: true, message: '请选择链' }]} style={{ flex: 1, minWidth: '180px', marginBottom: 0 }}>
                    <Select
                                        allowClear
                        placeholder="选择链"
                        value={selectedChain?.chain_id}
                        onChange={(value) => {
                            setSelectedChain(chains.find(chain => chain.chain_id === value));

                            form.setFieldsValue({ token_address: ''}); // 更新表单值
                        }}
                        style={{ width: '100%' }}
                    >
                        {chains.map((chain) => (
                            <Option key={chain.chain_id} value={chain.chain_id}>
                                {chain.chain_name}
                            </Option>
                        ))}
                    </Select>
                </Form.Item>

                <Form.Item
                    name="token_address"
                    rules={[{ required: true, message: '请选择或输入代币地址' }]}
                    style={{ flex: 1, minWidth: '180px' }}
                >
                    <AutoComplete
                        placeholder="查询的代币地址"
                        value={tokenAddress}
                        onChange={handleTokenAddressChange}
                        style={{ width: '100%', marginLeft: '20px', marginRight: '20px' }}
                        options={
                            selectedChain
                                ? Array.from(new Map(
                                    (tokenOptions[selectedChain.chain_name] || []).map(token => [token.address, {
                                        value: token.address,
                                        label: `${token.name} - ${token.address}`,
                                    }])
                                ).values()) // 使用 Map 去重
                                : []
                        }
                        filterOption={(inputValue, option) =>
                            option.label.toLowerCase().includes(inputValue.toLowerCase())
                        }
                    />
                </Form.Item>
            </Form>
                {/*<Input*/}
                {/*    placeholder="查询的代币地址"*/}
                {/*    value={tokenAddress}*/}
                {/*    onChange={(e) => setTokenAddress(e.target.value)}*/}
                {/*    style={{ flex: 1, minWidth: '180px' }}*/}
                {/*/>*/}

                <Button
                    type="primary"
                    onClick={() => {
                        if (!tokenAddress) {
                            // 弹窗提示用户填写 tokenAddress
                            message.warning('请输入代币地址');
                        } else {
                            fetchWallets(); // 调用查询余额的函数
                        }
                    }}
                    style={{ flex: 1, minWidth: '180px', marginLeft: '40px' }}
                >
                    查询余额
                </Button>


                <div
                    style={{
                        flex: 1,
                        minWidth: '180px',
                        fontSize: '14px',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        textAlign: 'center',
                    }}
                >
                    {totalBalance && <span>总余额：{totalBalance}</span>}
                </div>

                <Button danger onClick={deleteAddresses} style={{ flex: 1, minWidth: '180px' }}>
                    删除地址
                </Button>
            </div>

            <Table
                rowKey="address"
                columns={columns}
                dataSource={wallets}
                loading={loading}
                rowSelection={{
                    selectedRowKeys: selectedRows.map((row) => row.address),
                    onChange: (_, rows) => setSelectedRows(rows),
                }}
                rowClassName={(record) => {
                    console.log("🔍 当前行:", record.address, "高亮:", highlightedRow);
                    return record.address === highlightedRow ? 'highlight-row' : '';
                }}
                pagination={{
                    current: pagination.current,
                    pageSize: pagination.pageSize,
                    total: pagination.total,
                    showSizeChanger: false,
                    onChange: (page, pageSize) => {
                        setPagination((prevPagination) => ({
                            ...prevPagination,
                            current: page,
                            pageSize: pageSize,
                        }));
                    },
                }}
            />

            <Modal
                title="添加地址"
                visible={addAddressModalVisible}
                onCancel={() => setAddAddressModalVisible(false)}
                footer={null}
            >
                <div style={{ display: 'flex', gap: '10px', marginBottom: 20 }}>
                    <Input
                        placeholder="输入私钥"
                        value={addPrivateKey}
                        onChange={(e) => setAddPrivateKey(e.target.value)}
                        style={{ flex: 1 }}
                    />
                    <Button type="primary" onClick={() => addAddress(2)}>
                        添加私钥
                    </Button>
                    <Button onClick={() => addAddress(1)}>生成私钥</Button>
                </div>
            </Modal>
        </Content>

    );
};

export default ManageWallet;
